import React, { useEffect, useState } from "react";
import { teams } from "../../utils/constants";
import API from "../../services/api";
import { getReportLastDay, getReportMonthTimestamps } from "./reportDateUtils";

function TeamwiseNational(props) {
  const { month, year, newReports } = props;
  const [currentDay, setCurrentDay] = useState(getDaysInMonth(year, month - 1));
  const [teamWiseData, setTeamwiseData] = useState([])

  function getDaysInMonth(year, month) {
    return getReportLastDay(year, month);
  }
  function getStartAndEndOfMonthTimestamps(year, month) {
    return getReportMonthTimestamps(year, month);
  }

  const { startTimestamp, endTimestamp } = getStartAndEndOfMonthTimestamps(
    year,
    month
  );
  const getTimestamp = (times) => {
    const startDate = new Date(year, month - 1, 1); 
    // Convert to timestamps (in seconds)
    const timestampFirstDayOfMonth = Math.floor(startDate.getTime() / 1000);
    return timestampFirstDayOfMonth + (times * 86400)
  }
  function getTotalSpentByDateAndTeam(index, targetTeam) {
    const result = teamWiseData.find(item => item.date === getTimestamp(index) && item.team === targetTeam);
    return result ? parseFloat(result.totalSpent) : 0;
  }
  const fetchData = async() =>{
    try {
      let res = await API({
        url:"/reports/teamwise-national-reports",
        method:'POST',
        responseType:'json',
        data:{
          startTimestamp,
          endTimestamp,
          newReport:newReports
        }
      })
      if(res.code === 200){
        setTeamwiseData(res.data)
      }
    } catch (error) {
      console.error(error)
    }
  }

  const handleCurrentDay = () => {
    setCurrentDay(getDaysInMonth(year, month - 1));
  };

  const getTeamTotal = (teamName) => {
    let total = 0;
    teamWiseData?.map((entry) => {
      if (entry.team === teamName) {
        total += entry.totalSpent
      }
    })
    return total.toFixed(2);
  };

  const calculateAllTeamTotal = () => {
    if (teamWiseData.length) {
      let total = 0;
      teamWiseData?.forEach((entry) => {
        const teamExists = teams.slice(11, 15).some(team => team.value === entry.team);
        if (teamExists) {
          total += parseFloat(entry.totalSpent);
        }
      })
      return total.toFixed(2);
    } else {
      return 0;
    }
  };

  const calculateRowTotal = (index) =>{
    let total = 0;
    teamWiseData?.map((entry) => {
      if (entry.date === getTimestamp(index)) {
        total += parseFloat(entry.totalSpent);
      }
    })
    return total.toFixed(2);
  };
  

  useEffect(() => {
    fetchData();
    handleCurrentDay();
  }, [month, year, newReports]);
  return (
    <div className="report-image">
      <div className="overflow-x-auto responsive-table">
        <table
          className="table table-bordered report-table"
          id="consolidated-report"
        >
          <thead>
            <tr>
              <td colSpan={13}>
                <h4>National - Region Wise Report	</h4>
              </td>
            </tr>
            <tr>
              <td colSpan={13}>
                <h4>National Consolidated Region wise Revenue CPM	</h4>
              </td>
            </tr>
            <tr>
              <th>Date</th>
              {teams.slice(12, 18).map((fieldname, index) => {
                return <th>{fieldname.label}</th>;
              })}
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: currentDay }, (_, index1) => (
              <tr key={index1}>
                <td>{`${index1 + 1}-${month}-${year}`}</td>
                {teams.slice(12, 18).map((fieldname, index) => {
                  return (
                    <td title={parseFloat(getTotalSpentByDateAndTeam(index1, fieldname.value) || 0).toFixed(2)}>
                      {Math.round(getTotalSpentByDateAndTeam(index1, fieldname.value) || 0)}
                    </td>
                  );
                })}
                <td title={calculateRowTotal(index1)}>{Math.round(parseFloat(calculateRowTotal(index1)))}</td>
              </tr>
            ))}
            <tr>
              <td>Total</td>
              {teams.slice(12, 18).map((fieldname, index) => (
                <td key={index} title={getTeamTotal(fieldname.value)}>{Math.round(parseFloat(getTeamTotal(fieldname.value)))}</td>
              ))}
              <td title={calculateAllTeamTotal()}>{Math.round(parseFloat(calculateAllTeamTotal()))}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default TeamwiseNational;
